// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__bnYRa","placeholder":"styles_placeholder__WUr1v","editButton":"styles_editButton__U-At1","saveButton":"styles_saveButton__cwBVr"};